module.exports = __webpack_public_path__ + "static/img/iphone-logo.9f58d83d.png";